import React from 'react';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { Box, Typography } from '@mui/material';
import { NavigateFunction } from 'react-router-dom';
import Investor from '../../../models/Investor';
import ContactPortfolioFundCard from './ContactPortfolioFundCard';
import ContactPortfolioSectionCard from './ContactPortfolioSectionCard';
import type { FundBreakdownEntry } from './contactPortfolioTypes';

export default function ContactPortfolioActiveFundsSection({
  loading,
  portfolioInvestors,
  breakdownByFundId,
  navigate,
}: {
  loading: boolean;
  portfolioInvestors: Investor[];
  breakdownByFundId: Map<string, FundBreakdownEntry>;
  navigate: NavigateFunction;
}) {
  return (
    <ContactPortfolioSectionCard
      title="My Funds"
      icon={<ShowChartIcon sx={{ fontSize: 18, color: 'text.secondary' }} />}
      loading={loading}
    >
      {!loading && portfolioInvestors.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No committed investments.
        </Typography>
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {portfolioInvestors.map((inv) => {
          const fund = inv.fundOpportunity as { id?: string } | undefined;
          const fundExtId = fund?.id ?? inv.fundOpportunityId;
          return (
            <ContactPortfolioFundCard
              key={inv.id}
              investor={inv}
              breakdown={fundExtId ? breakdownByFundId.get(fundExtId) : undefined}
              navigate={navigate}
            />
          );
        })}
      </Box>
    </ContactPortfolioSectionCard>
  );
}
